import request from '@/utils/request'

export function registerCustomer(data) {
    return request({
        url: '/customer/register',
        method: 'post',
        data: data
    })
}

export function getInfo(id) {
    return request({
        url: '/customer/' + id,
        method: 'get',
    })
}

export function fetchList(params) {
    return request({
        url: '/customer/list',
        method: 'get',
        params: params
    })
}

export function updateCustomer(id, data) {
    return request({
        url: '/customer/update/' + id,
        method: 'post',
        data: data
    })
}

export function updateStatus(id, params) {
    return request({
        url: '/customer/updateStatus/' + id,
        method: 'post',
        params: params
    })
}

export function deleteCustomer(params) {
    return request({
        url: '/customer/delete/',
        method: 'post',
        params: params
    })
}